.border__radius__lg {
  border-radius: var(--border-radius-lg);
}
